import React, { useContext } from "react";
import { TwoUIComponentQosContextType } from "../TwoUIComponentQosProvider/TwoUIComponentQosProvider";
import { TwoUIOperationAction } from "../TwoUIOperationProvider/TwoUIOperationProvider";
import { TwoUIProgressViewType } from "../TwoUIProgressView/TwoUIBasicProgressView/TwoUIBasicProgressView";

/**
 * External entities provided by TwoUI consumer for manager Operation
 */
export interface ExternalOperationEntities {
    /**
     * Provider dispatcher to change operation state
     */
    readonly operationDispatchContext: React.Context<React.Dispatch<TwoUIOperationAction> | null>;

    /**
     * Externally provided progress view implementation
     */
    readonly ExternalProgressView: TwoUIProgressViewType;
}

/**
 * Collection of external entity will be provided to TwoUI
 */
export interface ExternalEntities {
    /**
     * Entities managing operation state
     */
    readonly operationEntities?: ExternalOperationEntities;

    /**
     * Entities managing component Qos context
     */
    readonly componentQosContext?: React.Context<TwoUIComponentQosContextType | null>;
}

const externalEntitiesContext = React.createContext<ExternalEntities>({});

/**
 * Props of TwoUI's external entity provider
 */
export interface ExternalEntitiesProviderProps {
    readonly externalEntities?: ExternalEntities;
}

/**
 * Provider external entity provided by TwoUI user.
 */
export const ExternalEntitiesProvider: React.FC<ExternalEntitiesProviderProps> = ({
    children,
    externalEntities
}) => {

    // If user is not providing any external entity, we create an empty
    // external entities object to avoid checking if external entities object is
    // null or not in many places.
    return (
        <externalEntitiesContext.Provider
            value={externalEntities ?? {}}
        >
            {children}
        </externalEntitiesContext.Provider>
    );
};

/**
 * Get access to external entity consumer providing to TwoUI
 * @returns external entities
 */
export const useExternalEntities = (): ExternalEntities => {
    return useContext(externalEntitiesContext);
};
